import React from "react";
import StatusBadge from "./StatusBadge";

const ClockIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
    <path d="M12 7v5l3 2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

const STATIC_HINT = {
  emerges: "Emerges as your system builds. Available after all other areas are complete.",
};

const ElementRow = ({ item, onClick }) => {
  const { icon, title, description, duration, status } = item;
  const isInteractive = status === "completed" || status === "next_up";
  const stateClass =
    status === "locked" ? "is-locked" :
    status === "emerges" ? "is-emerges" :
    status === "completed" ? "is-completed" :
    status === "next_up" ? "is-next-up" : "";

  const handleClick = () => {
    if (!isInteractive) return;
    if (typeof onClick === "function") onClick(item);
  };

  return (
    <button
      type="button"
      className={`ye-row ${stateClass}`}
      onClick={handleClick}
      disabled={!isInteractive}
      aria-disabled={!isInteractive}
    >
      <div className="ye-row-icon">
        {icon ? <img src={icon} alt="" /> : null}
      </div>
      <h3 className="ye-row-title">{title}</h3>
      <StatusBadge status={status} />
      <p className="ye-row-description">{description}</p>
      {STATIC_HINT[status] && (
        <p className="ye-row-extra">{STATIC_HINT[status]}</p>
      )}
    </button>
  );
};

export default ElementRow;
